import { useMutation } from '@/react-query/hooks/useMutation/useMutation';
import { revalidate } from '@/services/revalidate/revalidate';
import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';

const useUpdatePromotionalBanner = () => {
  const queryClient = useQueryClient();
  const { mutateAsync, isPending } = useMutation('updatePromotionalBanner', {
    onSuccess: async (res) => {
      await revalidate(['banners']);
      toast.success(res.message);
      await queryClient.invalidateQueries({ queryKey: ['promotional-banner'] });
    },
    onError: (err) => {
      toast.error(err.message);
    },
  });
  return { mutateAsync, isPending };
};

export default useUpdatePromotionalBanner;
